(function() {
    'use strict';

    angular
        .module('app.layout')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper, DOMAINCONFIG, DOMAINMODE) {
        var stateConfig = getStates();
        //console.log('DOMAINCONFIG = ', JSON.stringify(DOMAINCONFIG));
        if(DOMAINCONFIG && ! _.isEmpty(DOMAINCONFIG)) {
            if(DOMAINMODE != 'l'){
                stateConfig[0].config.params = DOMAINCONFIG;
            }
        }
        console.log('state = ',stateConfig);
        routerHelper.configureStates(stateConfig);
    }

    function getStates() {
        return [
            {
                state: 'layout',
                config: {
                    url:  '/{language:(?:fr|en)}', // '/{language:[fr|en]}', // '/:language?embded', //
                    controller:'LayoutController',
                    abstract: true,
                    template: require('html!./shell.html'),
                    resolve:{/*@ngInject*/
                        language : function ($stateParams){
                            return $stateParams.language;
                        }
                    }
                }
            }
        ];
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/layout.route.js
 ** module id = 223
 ** module chunks = 0
 **/